

<div fxFlex>
    <button  mat-raised-button (click)="open()"  class="btncss" >{{menuData.categoryName}}
    </button>
</div>